export default [
  [
    "base",
    "",
    ["read"],
    {
      crud: {
        read: {
          provinceOptions: "provinces",
          cityOptions: "cities",
          schoolOptions: "schools",
        },
      },
    },
  ],
];
